module.exports = __webpack_public_path__ + "static/media/Receipe4.81b35ad5.svg";